import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ec0b82e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "edit-role",
  class: "d-flex flex-fill edit-page-100"
}
const _hoisted_2 = { class: "card border-0 background-fb" }
const _hoisted_3 = { class: "edit-header" }
const _hoisted_4 = { class: "label" }
const _hoisted_5 = { class: "card-body overflow-auto font-size-14" }
const _hoisted_6 = { id: "role-draft" }
const _hoisted_7 = { class: "row-grid" }
const _hoisted_8 = { class: "d-flex flex-column width-50 padding-lr" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1))
const _hoisted_10 = { class: "d-flex flex-column width-50 padding-lr" }
const _hoisted_11 = { class: "d-flex flex-column margin-top-10 padding-lr" }
const _hoisted_12 = { class: "d-flex flex-row justify-content-between" }
const _hoisted_13 = { class: "d-flex flex-row justify-content-end align-items-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mt-2 mb-2" }, null, -1))
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["id", "value"]
const _hoisted_17 = ["for"]
const _hoisted_18 = {
  key: 1,
  class: "row-grid"
}
const _hoisted_19 = {
  key: 0,
  class: "accordion mt-2 margin-lr"
}
const _hoisted_20 = { class: "accordion-item" }
const _hoisted_21 = ["id"]
const _hoisted_22 = ["data-bs-target"]
const _hoisted_23 = ["id", "aria-labelledby"]
const _hoisted_24 = { class: "accordion-body" }
const _hoisted_25 = ["disabled", "id", "value"]
const _hoisted_26 = ["for"]
const _hoisted_27 = {
  key: 0,
  class: "accordion mt-2 margin-lr"
}
const _hoisted_28 = { class: "accordion-item" }
const _hoisted_29 = ["id"]
const _hoisted_30 = ["data-bs-target"]
const _hoisted_31 = ["id", "aria-labelledby"]
const _hoisted_32 = { class: "accordion-body" }
const _hoisted_33 = ["id", "disabled", "value"]
const _hoisted_34 = ["for"]
const _hoisted_35 = { class: "card-footer footer" }
const _hoisted_36 = { class: "float-right" }
const _hoisted_37 = { class: "loader-div-40" }
const _hoisted_38 = ["src"]

import { computed, onBeforeMount, ref } from "vue";
import { ElButton, ElInput, ElScrollbar } from "element-plus";
import { groupBy } from "lodash-es";
import { TYPE } from "vue-toastification";
import { currentRoute, router } from "@/core/router";
import { hasPermission } from "@/core/auth";
import { getPrivilegeList } from "@/privilege/services/privilege.service";
import { addRole, editRole, getRole } from "@/role/services/role.service";
import { showAlert } from "@/core/popup";
import i18n from "@/core/i18n/i18n";
import { ASSETS_BASE_URL, DEFAULT_LOGO } from "@/core/logo";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditRoles',
  setup(__props) {

const { t } = i18n.global;

const pageName = ref(
  currentRoute.value.name === "createRoles"
    ? t("Common.Create")
    : t("Common.Edit")
);

const groupedObject = ref({});

const privileges = ref([]);

const selectedPrivileges = ref(["865b462d-945c-4713-9827-703299feef62"]);

const search = ref("");

const pageLoading = ref(false);

const responseLoading = ref(false);

const role = ref({
  authority: "",
  description: "",
  privileges: ["865b462d-945c-4713-9827-703299feef62"],
});

const id = ref("");

const isValid = computed(() => role.value.authority !== "");

const collapseList = computed(() => {
  const list = [];
  Object.keys(groupedObject.value).forEach((item, index) => {
    list.push(`#collapse-${index}`);
  });
  return list;
});

function groupFets() {
  return groupBy(privileges.value, (token) =>
    toPascalCase(token.privilegeId.split(".")[0])
  );
}

function toPascalCase(text) {
  return text
    .toLowerCase()
    .replace(/[^a-zA-Z0-9]+(.)/g, (_, chr) => chr.toUpperCase())
    .replace(/^./, (chr) => chr.toUpperCase());
}

async function getPrivileges() {
  await getPrivilegeList().then((response) => {
    if (response) {
      privileges.value = response;
    }
  });
}

function selectOrDiscardAll(list: any[]) {
  if (isContainsAll(list)) {
    list.forEach((item) => {
      const index = selectedPrivileges.value.findIndex(
        (selectedId) => selectedId === item.id
      );
      if (index !== -1) {
        selectedPrivileges.value.splice(index, 1);
      }
    });
  } else {
    list.forEach((item) => {
      if (
        !selectedPrivileges.value.find((selectedId) => selectedId === item.id)
      ) {
        selectedPrivileges.value.push(item.id);
      }
    });
  }
}

function isContainsAll(list: any[]): boolean {
  let returnVal = true;
  list.forEach((item) => {
    if (
      !selectedPrivileges.value.find((selectedId) => selectedId === item.id)
    ) {
      returnVal = false;
    }
  });
  return returnVal;
}

async function saveFet() {
  responseLoading.value = true;

  if (!hasPermission("ROLES.ROLE.SAVE")) {
    showAlert(TYPE.WARNING, t("Common.NoPermissionMsg"));
    responseLoading.value = false;
    return;
  }

  if (!isValid.value) {
    showAlert(TYPE.WARNING, t("Common.WarningMsg"));
    responseLoading.value = false;
    return;
  }

  role.value.privileges = privileges.value.filter((privilege) =>
    selectedPrivileges.value.includes(privilege.id)
  );

  try {
    let result: any;
    if (id.value) {
      result = await editRole(role.value);
      if (result) {
        showAlert(TYPE.SUCCESS, t("Role.RoleUpdated"));
      }
    } else {
      result = await addRole(role.value);
      if (result) {
        showAlert(TYPE.SUCCESS, t("Role.RoleCreated"));
      }
    }

    setTimeout(() => {
      window.location.reload();
    }, 1000);
  } catch (error) {
    showAlert(TYPE.ERROR, t("Common.ErrorMsg"));
  } finally {
    responseLoading.value = false;
  }
}

onBeforeMount(async () => {
  pageLoading.value = true;
  await getPrivileges();
  groupedObject.value = groupFets();
  id.value = currentRoute.value.params.id as string;
  if (id.value) {
    await getRole(id.value).then((response) => {
      if (response) {
        role.value = response;
        response.privileges.forEach((privilege) => {
          selectedPrivileges.value.push(privilege.id);
        });
      }
    });
  }
  pageLoading.value = false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(pageName.value) + " " + _toDisplayString(_unref(t)("Role.Roles")), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("strong", null, [
                _createTextVNode(_toDisplayString(_unref(t)("Role.Authority")), 1),
                _hoisted_9
              ]),
              _createVNode(_unref(ElInput), {
                modelValue: role.value.authority,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((role.value.authority) = $event)),
                size: "small",
                placeholder: _unref(t)('Common.Name')
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.Description")), 1),
              _createVNode(_unref(ElInput), {
                modelValue: role.value.description,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((role.value.description) = $event)),
                size: "small",
                placeholder: _unref(t)('Common.Description')
              }, null, 8, ["modelValue", "placeholder"])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("strong", null, _toDisplayString(_unref(t)("Privilege.Privileges")), 1),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_unref(ElButton), {
                  size: "mini",
                  "data-bs-toggle": "collapse",
                  "data-bs-target": collapseList.value,
                  "aria-expanded": "false",
                  "aria-controls": "collapseOne"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("Role.ExpandAll")), 1)
                  ]),
                  _: 1
                }, 8, ["data-bs-target"]),
                _createVNode(_unref(ElInput), {
                  modelValue: search.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((search).value = $event)),
                  class: "ml-5",
                  clearable: "",
                  size: "mini",
                  style: {"max-width":"170px"},
                  placeholder: _unref(t)('Common.TypeToSearch')
                }, null, 8, ["modelValue", "placeholder"])
              ])
            ]),
            _hoisted_14,
            _createVNode(_unref(ElScrollbar), { "max-height": '65vh' }, {
              default: _withCtx(() => [
                (search.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(privileges.value.filter((privilege) =>
                    privilege.name.toUpperCase().includes(search.value.toUpperCase())
                  ), (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "mt-2",
                          key: index
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            id: item.name,
                            value: item.id,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedPrivileges).value = $event))
                          }, null, 8, _hoisted_16), [
                            [_vModelCheckbox, selectedPrivileges.value]
                          ]),
                          _createElementVNode("label", {
                            for: item.name,
                            class: "margin-left-3"
                          }, _toDisplayString(item.name), 9, _hoisted_17)
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createVNode(_unref(ElScrollbar), {
                        "max-height": '65vh',
                        class: "width-50"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedObject.value, (value, key, index) => {
                            return (_openBlock(), _createElementBlock("div", { key: index }, [
                              (index % 2 === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    _createElementVNode("div", _hoisted_20, [
                                      _createElementVNode("h2", {
                                        class: "accordion-header",
                                        id: 'heading-' + index
                                      }, [
                                        _createElementVNode("button", {
                                          class: "accordion-button collapsed font-size-14 max-height-32",
                                          type: "button",
                                          "data-bs-toggle": "collapse",
                                          "data-bs-target": '#collapse-' + index,
                                          "aria-expanded": "false",
                                          "aria-controls": "collapseOne"
                                        }, [
                                          _createElementVNode("strong", null, _toDisplayString(key), 1)
                                        ], 8, _hoisted_22)
                                      ], 8, _hoisted_21),
                                      _createElementVNode("div", {
                                        id: 'collapse-' + index,
                                        class: "accordion-collapse collapse collapse-all",
                                        "aria-labelledby": 'heading-' + index
                                      }, [
                                        _createElementVNode("div", _hoisted_24, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (item, index) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              class: "mt-2 justify-content-between d-flex flex-row",
                                              key: index
                                            }, [
                                              _createElementVNode("div", null, [
                                                _withDirectives(_createElementVNode("input", {
                                                  type: "checkbox",
                                                  disabled: 
                                    item.privilegeId === 'DASHBOARD.MAIN.VIEW'
                                  ,
                                                  id: item.name,
                                                  value: item.id,
                                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedPrivileges).value = $event))
                                                }, null, 8, _hoisted_25), [
                                                  [_vModelCheckbox, selectedPrivileges.value]
                                                ]),
                                                _createElementVNode("label", {
                                                  for: item.name,
                                                  class: "margin-left-3"
                                                }, _toDisplayString(item.name), 9, _hoisted_26)
                                              ]),
                                              (index === 0)
                                                ? (_openBlock(), _createBlock(_unref(ElButton), {
                                                    key: 0,
                                                    class: "btn-custom",
                                                    size: "mini",
                                                    onClick: _withModifiers(($event: any) => (selectOrDiscardAll(value)), ["stop"]),
                                                    disabled: 
                                  item.privilegeId === 'DASHBOARD.MAIN.VIEW'
                                
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(isContainsAll(value) ? "Clear" : "Select All"), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick", "disabled"]))
                                                : _createCommentVNode("", true)
                                            ]))
                                          }), 128))
                                        ])
                                      ], 8, _hoisted_23)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(ElScrollbar), {
                        "max-height": '65vh',
                        class: "width-50"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedObject.value, (value, key, index) => {
                            return (_openBlock(), _createElementBlock("div", { key: index }, [
                              (index % 2 === 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                    _createElementVNode("div", _hoisted_28, [
                                      _createElementVNode("h2", {
                                        class: "accordion-header",
                                        id: 'heading-' + index
                                      }, [
                                        _createElementVNode("button", {
                                          class: "accordion-button collapsed font-size-14 max-height-32",
                                          type: "button",
                                          "data-bs-toggle": "collapse",
                                          "data-bs-target": '#collapse-' + index,
                                          "aria-expanded": "false",
                                          "aria-controls": "collapseOne"
                                        }, [
                                          _createElementVNode("strong", null, _toDisplayString(key), 1)
                                        ], 8, _hoisted_30)
                                      ], 8, _hoisted_29),
                                      _createElementVNode("div", {
                                        id: 'collapse-' + index,
                                        class: "accordion-collapse collapse collapse-all",
                                        "aria-labelledby": 'heading-' + index
                                      }, [
                                        _createElementVNode("div", _hoisted_32, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (item, index) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              class: "mt-2 justify-content-between d-flex flex-row",
                                              key: index
                                            }, [
                                              _createElementVNode("div", null, [
                                                _withDirectives(_createElementVNode("input", {
                                                  type: "checkbox",
                                                  id: item.name,
                                                  disabled: 
                                    item.privilegeId === 'DASHBOARD.MAIN.VIEW'
                                  ,
                                                  value: item.id,
                                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedPrivileges).value = $event))
                                                }, null, 8, _hoisted_33), [
                                                  [_vModelCheckbox, selectedPrivileges.value]
                                                ]),
                                                _createElementVNode("label", {
                                                  for: item.name,
                                                  class: "margin-left-3"
                                                }, _toDisplayString(item.name), 9, _hoisted_34)
                                              ]),
                                              (index === 0)
                                                ? (_openBlock(), _createBlock(_unref(ElButton), {
                                                    key: 0,
                                                    class: "btn-custom",
                                                    size: "mini",
                                                    onClick: _withModifiers(($event: any) => (selectOrDiscardAll(value)), ["stop"]),
                                                    disabled: 
                                  item.privilegeId === 'DASHBOARD.MAIN.VIEW'
                                
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(isContainsAll(value) ? "Clear" : "Select All"), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick", "disabled"]))
                                                : _createCommentVNode("", true)
                                            ]))
                                          }), 128))
                                        ])
                                      ], 8, _hoisted_31)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]))
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createVNode(_unref(ElButton), {
            class: "btn-oneTeg3",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(router).push('/roles')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("Common.Back")), 1)
            ]),
            _: 1
          }),
          (_unref(hasPermission)('ROLES.ROLE.SAVE'))
            ? (_openBlock(), _createBlock(_unref(ElButton), {
                key: 0,
                class: "btn-oneTeg2",
                onClick: saveFet
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("Common.Save")), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ], 512), [
      [_vShow, !pageLoading.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_37, [
      _createElementVNode("img", {
        src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
        alt: "Loading...",
        class: "loader-logo-40"
      }, null, 8, _hoisted_38)
    ], 512), [
      [_vShow, responseLoading.value || pageLoading.value]
    ])
  ]))
}
}

})